// extracted by mini-css-extract-plugin
export default {"products":"Rz-z","card":"Sz-z","oosMessaging":"Tz-z"};